var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st0 {\n\t\t\tfill: #414141\n\t\t}\n\n\t\t.prefix__st1 {\n\t\t\tstroke-linecap: round\n\t\t}\n\n\t\t.prefix__st1,\n\t\t.prefix__st2 {\n\t\t\tfill-rule: evenodd;\n\t\t\tclip-rule: evenodd;\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M2.3 16.3c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3S1 18.3 1 17.6s.6-1.3 1.3-1.3m0-1c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3-1-2.3-2.3-2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M2.7 12.2l3.5 4.6h11M8.1 4.1h13.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st2",
    d: "M21 16.8h2v-4.6h-4.3c-2.6 0-4.6 2.1-4.6 4.6h2.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M19.1 16.3c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3-1.3-.6-1.3-1.3.6-1.3 1.3-1.3m0-1c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3-1-2.3-2.3-2.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st2",
    d: "M19.5 4.1v7.7M5 14.9l4.7-4.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M8.1 9.1l2.7 2.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfCart);
export default __webpack_public_path__ + "static/media/golf-cart.f022a4ce9120a7a03a6b4370f9fcbf5e.svg";
export { ForwardRef as ReactComponent };